import { useCallback, useState } from "react";
import { makeStyles } from "tss-react/mui";
import { Grid, Tab, Tabs } from "@mui/material";
import { useTranslation } from "react-i18next";
import ResponsivePage from "../../common/core/ResponsivePage";
import config from "../../../config";
import FullDispatchView from "./common/FullDispatchView";
import { useDevice } from "../../../providers/DeviceProvider";
import DispatchToolbar from "./common/DispatchToolbar";
import { getLocalStorageValue } from "../../../common/helpers";
import SlimDispatchView from "./common/SlimDispatchView";
import { AddMissionFab } from "../../../hooks/useAddMissionFab";
import { useDispatch } from "./providers/DispatchProvider";

const useStyles = makeStyles()(
  (theme) => ({
    headerWidget: {
      background: theme.palette.background.default,
      zIndex: 2,
    },
    tabs: {
      borderBottom: `2px solid ${theme.palette.divider}`,
    },
  })
);

export default function DispatchLayout() {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { slim } = useDevice();

  const [tabIndex, setTabIndex] = useState(0);
  const onChangeTabIndex = useCallback((_, idx) => setTabIndex(idx), []);

  const { activeTasks, completedTasks } = useDispatch();

  const [orderTasksBy, setOrderTasksBy] = useState(getLocalStorageValue("orderTasksBy", "new"));
  const [filterTasksBy, setFilterTasksBy] = useState(JSON.parse(getLocalStorageValue("filterTasksByMultiple", "[]")));

  return (
    <ResponsivePage
      title={t("dispatch:title")}
      maxWidth={config.pageSize.full}
      outerChildren={
        slim && tabIndex === 0 ? (
          <DispatchToolbar
            orderTasksBy={orderTasksBy}
            setOrderTasksBy={setOrderTasksBy}
            filterTasksBy={filterTasksBy}
            setFilterTasksBy={setFilterTasksBy}
          />
        ) : null
      }
      headerWidget={
        slim ? (
          <Grid item xs={12} className={classes.headerWidget}>
            <Tabs className={classes.tabs} onChange={onChangeTabIndex} value={tabIndex} variant="fullWidth" >
              <Tab value={0} label={`${t("dispatch:activeTasks:title")} (${activeTasks.length})`} />
              <Tab value={1} label={`${t("dispatch:completedTasks:title")} (${completedTasks.length})`} />
            </Tabs>
          </Grid>
        ) : null
      }
    >

      <AddMissionFab />

      {
        slim ? (
          <SlimDispatchView
            tabIndex={tabIndex}
            orderTasksBy={orderTasksBy}
            filterTasksBy={filterTasksBy}
          />
        ) : (
          <FullDispatchView />
        )
      }

    </ResponsivePage>
  );
}